<div class="card" >
  <div class="ng-Header col-xs-12">
    <div *ngIf="inspectionOfficerId == null">
      <i nz-icon nzType="form" nzTheme="outline"></i> Create Inspection Officer
    </div>
    <div *ngIf="inspectionOfficerId != null">
      <i nz-icon nzType="form" nzTheme="outline"></i> Edit Inspection Officer
    </div>
  </div>

  <!-- {{agencyUserForm.value | json}} -->
  <div class="searchboxAerar p-3">
    <form nz-form [formGroup]="inspectionOfficerForm" (ngSubmit)="onSubmit()">
      <div class="col-md-9">

        <div class="mb-2 row">
          <div class="col-md-7 col-sm-12 text-right">
            <nz-form-label nzRequired>Name
            </nz-form-label>
          </div>
          <div class="col-md-5 col-sm-12">
            <nz-form-item>
              <nz-form-control nzHasFeedback nzAllowClear class="row" [nzErrorTip]="nameErrorTpl">
                <input nz-input type="text" placeholder="Name" formControlName="name"/>
              </nz-form-control>
            </nz-form-item>
            <ng-template #nameErrorTpl let-control>
              <ng-container *ngIf="control.hasError('required')">
                Please input name !
              </ng-container>
            </ng-template>
          </div>
        </div>

        <div class="mb-2 row">
          <div class="col-md-7 col-sm-12 text-right">
            <nz-form-label nzRequired>Email
            </nz-form-label>
          </div>
          <div class="col-md-5 col-sm-12">
            <nz-form-item>
              <nz-form-control nzHasFeedback nzAllowClear class="row" [nzErrorTip]="emailErrorTpl">
                <input nz-input type="email" placeholder="Email" formControlName="email"/>
              </nz-form-control>
            </nz-form-item>
            <ng-template #emailErrorTpl let-control>
              <ng-container *ngIf="control.hasError('required')">
                Please input email !
              </ng-container>
              <ng-container *ngIf="control.hasError('whitespace')">
                Please enter valid email !
              </ng-container>
              <ng-container *ngIf="control.hasError('email')">
                Please enter valid email !
              </ng-container>
            </ng-template>
          </div>
        </div>

        <div class="mb-2 row">
          <div class="col-md-7 col-sm-12 text-right">
            <nz-form-label nzRequired>Contact No
            </nz-form-label>
          </div>
          <div class="col-md-5 col-sm-12">
            <nz-form-item>
              <nz-form-control nzHasFeedback nzAllowClear class="row" [nzErrorTip]="phoneErrorTpl">
                <input nz-input type="text" value="+880" style="width: 24%; text-align: left;" disabled/>
                <input nz-input type="text" placeholder="Ex: 1XXXXXXXXX" formControlName="phone" style="width: 76%;"
                (keyup)="checkContactNumberIfExist($event.target)"/>
              </nz-form-control>
            </nz-form-item>
            <ng-template #phoneErrorTpl let-control>
              <ng-container *ngIf="control.hasError('required')">
                Please input contact number !
              </ng-container>
              <ng-container *ngIf="control.hasError('pattern')">
                <div>Contact no must be 10 digits and only accepts number. Example:"1XXXXXXXXX"</div>
              </ng-container>
              <ng-container *ngIf="contactNumberAlreadyExist" class="text-danger">
                <div>This contact number already exists !</div>
              </ng-container>
            </ng-template>
          </div>
        </div>

        <div class="mb-2 row">
          <div class="col-md-7 col-sm-12 text-right">
            <nz-form-label>Designation
            </nz-form-label>
          </div>
          <div class="col-md-5">
            <nz-form-item>
              <nz-form-control nzHasFeedback nzAllowClear class="row">
                <input nz-input type="text" placeholder="Designation" formControlName="designation" />
              </nz-form-control>
            </nz-form-item>
          </div>
        </div>
      </div>

      <div class="row justify-content-center media-button">
        <div class="col-xs-6 col-sm-2">
          <button *ngIf="inspectionOfficerId == null || inspectionOfficerId == 0" type="submit" class="btn btn-success active btn-lg btn-block cari border-redius"
          [disabled]="!inspectionOfficerForm.valid" nz-popconfirm
          nzPopconfirmTitle="Are you sure you want to create this officer?"(nzOnConfirm)="onSubmit()"><i nz-icon nzType="save" nzTheme="fill"></i> Save
          </button>
          <button *ngIf="inspectionOfficerId != null" type="submit" class="btn btn-danger active btn-lg btn-block cari border-redius"
            [disabled]="!inspectionOfficerForm.valid" nz-popconfirm
            nzPopconfirmTitle="Are you sure you want to update this officer?"(nzOnConfirm)="onSubmit()"><i nz-icon nzType="save" nzTheme="fill"></i> Update
          </button>
        </div>
      </div>
    </form>
  </div>

</div>
